import { useState } from 'react';

import { Modal } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './MyAccount.module.css';
import { useGetStateQuery } from '../../api/lendingApi/lendingApiQueries';
import { Button } from '../Button/Button';

type TProps = {
  isDesktop?: boolean;
};

const MyAccount = ({ isDesktop }: TProps) => {
  const [showMyAccountModal, setShowMyAccountModal] = useState(false);

  const { state } = useGetStateQuery();
  const { t } = useLingui();

  const email = state?.application?.people?.[0].emails?.[0]?.email;

  if (!email) {
    return null;
  }

  return (
    <div
      className={clsx({
        [styles.myAccountButtonContainerDesktop]: isDesktop,
      })}
    >
      <Button
        size="small"
        variant="tertiary"
        onClick={() => setShowMyAccountModal(true)}
      >
        <Trans>My account</Trans>
      </Button>
      <Modal
        className={styles.modalContainer}
        isOpen={showMyAccountModal}
        onClose={() => setShowMyAccountModal(false)}
        title={t`My account`}
        size="medium"
      >
        <div className={styles.modalContents}>
          <p className={styles.setupAccountMessage}>
            <Trans>You can log in to this application with this email:</Trans>
            <span
              className={clsx('fs-mask dd-privacy-mask', styles.emailCreated)}
            >
              {email}
            </span>
          </p>
          <Button
            className={styles.closeButton}
            onClick={() => setShowMyAccountModal(false)}
          >
            <Trans>Got it</Trans>
          </Button>
          <div className={styles.logoutContainer}>
            <a className={styles.logout} href="/my_account/logout/">
              <Trans>Log out</Trans>
            </a>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MyAccount;
